import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import moment from '../../../logic/moment';

const EditButton = ({ booking, disableButtons }) => {
  if (moment(booking.check_in).isBefore(moment(), 'minute')) {
    return null;
  }

  return (
    <Box mb={4} mt={4}>
      <Typography variant="subtitle2">
        <FormattedMessage id="bookingForm.update" defaultMessage="Modify booking" />
      </Typography>
      <Typography paragraph>
        <FormattedMessage
          id="booking.updateExplanation"
          defaultMessage="If you would like to change the booking conditions use the button below"
        />
      </Typography>
      <Button
        variant="contained"
        color="primary"
        disabled={disableButtons}
        component={Link}
        to={`/conversations/${booking.conversation_id}/bookings/${booking.id}/edit`}
      >
        <FormattedMessage
          id="bookingInfo.changeExpiration"
          defaultMessage="Change expiration date"
        />
      </Button>
    </Box>
  );
};

EditButton.propTypes = {
  booking: PropTypes.shape({
    check_in: PropTypes.string.isRequired,
    conversation_id: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
  disableButtons: PropTypes.bool,
};

export default EditButton;
